import React from "react";
import Item from "../Item";
import { items } from "./data";

const List = ({ variants }) => {
  return (
    <div className="section darkSec noPadTop zPos">
      <div className="container-lg flex flexRow flexWrap gap relative">
        {items.map((item) => (
          <Item
            key={item.id}
            id={item.id}
            icon={item.icon}
            title={item.title}
            resume={item.resume}
            cuando={item.cuando}
            beneficio={item.beneficio}
            /* Ani */
            variants={variants}
          />
        ))}
      </div>
    </div>
  );
};

export default List;
